module.exports = __webpack_public_path__ + "img/jsmb-logo-white.d0170931.svg";